import { render, staticRenderFns } from "./ConsultList.vue?vue&type=template&id=3bbd4600&scoped=true&"
import script from "./ConsultList.vue?vue&type=script&lang=js&"
export * from "./ConsultList.vue?vue&type=script&lang=js&"
import style0 from "./ConsultList.vue?vue&type=style&index=0&id=3bbd4600&scoped=true&lang=css&"
import style1 from "./ConsultList.vue?vue&type=style&index=1&id=3bbd4600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd4600",
  null
  
)

export default component.exports